import Footer from "../../components/footer"
import Menu from "../../components/menu"
import { NextSeo } from "next-seo"
import GhostContentAPI from "@tryghost/content-api"
import Link from "next/link"
import { useEffect, useState } from "react"
import { BsFacebook, BsInstagram, BsLinkedin, BsTwitter, BsYoutube } from "react-icons/bs"
import { FaTiktok } from "react-icons/fa"
import dayjs from "dayjs"
import { EmailShareButton, FacebookShareButton, WhatsappShareButton } from "next-share"
import { FaFacebookF, FaWhatsapp } from "react-icons/fa"
import { BsEnvelopeAt, BsLink45Deg } from "react-icons/bs"
import { Popover } from "react-tiny-popover"
import "mapbox-gl/dist/mapbox-gl.css"

export async function getServerSideProps(context) {
  const api = new GhostContentAPI({
    url: "http://www.huntleys.net/_ghost",
    key: "0969111e255e7972faad8897ec",
    version: "v5.0",
  })

  let post = null

  try {
    post = await api.posts.read({ slug: context.params?.slug }, { formats: ["html", "plaintext"], include: ["authors"] })
  } catch (err) {
    console.error(err)
  }

  if (!post) {
    return {
      redirect: {
        permanent: false,
        destination: "/articles",
      },
    }
  }

  post.html = post.html.replaceAll(/srcset=".*?"/g, "")
  post.html = post.html.replaceAll("http://", "https://")

  return {
    props: {
      post,
    },
  }
}

function BlogPost({ post }) {
  if (!post) {
    return (
      <>
        <NextSeo title="Blog Post Not Found" />
        <div className="relative h-full max-h-screen min-h-screen">
          <img className="object-cover w-screen h-screen" src="/images/team-2.webp" />
          <div className="absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center w-full bg-opacity-50 select-none backdrop-blur-sm bg-stone-900">
            {/* <h1 className="font-serif text-6xl font-bold text-white">
              Page Not Found
            </h1> */}
            {/* <div className="block mt-6 h-96">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 230 52"
                className="object-contain w-full h-full"
              >
                <path
                  fill="#fff"
                  d="M26.235 34.235V23.529H13.176v10.706l3.883 3.53v1.294H0v-1.295l3.882-3.529V8.588L0 5.058V3.766h17.059V5.06l-3.883 3.53v11.176h13.06V8.588l-3.883-3.53V3.766H39.41V5.06l-3.882 3.53v25.646l3.882 3.53v1.294H22.235v-1.295l4-3.529zM44.823 18.47l-3.176-2.352v-1.294L53.41 12v15.53c0 1.882.353 3.293.941 4.235.589.823 1.647 1.294 3.059 1.294 1.176 0 2.588-.353 4.118-.941V18.47l-3.177-2.353v-1.294L70.117 12v22.117l4.235 1.648v1.294l-9.294 2.706-3.53-4.706c-.94 1.411-2 2.47-3.411 3.294-1.412.823-2.941 1.176-4.588 1.176-2.706 0-4.824-.823-6.353-2.47-1.647-1.647-2.47-3.883-2.47-6.706V18.47h.117zm52.235 16.706V24c0-3.647-1.294-5.53-3.882-5.53-1.647 0-3.177.471-4.706 1.412v15.294l2.942 2.588v1.295H76.588v-1.294l3.176-2.589v-16.47l-3.411-2.47V14.94L86 11.882l1.647 4.824c1.411-1.53 2.941-2.706 4.47-3.53 1.53-.823 3.177-1.176 5.06-1.176 2.587 0 4.705.823 6.234 2.47 1.529 1.648 2.353 3.883 2.353 6.706v14.118L108.94 38v1.294H94.117V38l2.941-2.824zm26.118-29.411v6.588h7.058v3.764h-7.058v14c0 1.883.353 3.177.941 3.883s1.647 1.059 2.941 1.059c1.412 0 2.824-.118 3.882-.471v1.294c-.47.47-1.176 1.059-2.235 1.647-.941.588-2.117 1.177-3.412 1.53-1.293.352-2.588.588-3.764.588-2.236 0-4-.588-5.294-2-1.294-1.294-1.883-3.177-1.883-5.53v-16h-4.118v-2.47l4.118-.588V7.765l8.824-2zm13.175 29.411V6.471l-3.176-2.353V2.824L144.94 0v35.176l3.176 2.588v1.294h-14.941v-1.294l3.176-2.588zm39.765-9.882h-15.647c.118 2 .471 3.647.942 4.941.471 1.412 1.412 2.47 2.588 3.294 1.177.824 2.941 1.294 5.177 1.294 1.764 0 3.764-.353 5.882-1.176l.823 1.647c-1.176 1.294-2.706 2.235-4.588 3.059-1.882.823-3.882 1.176-6.235 1.176-4.353 0-7.765-1.176-10.236-3.53-2.47-2.352-3.646-5.646-3.646-9.882 0-1.882.352-3.647.941-5.411a11.568 11.568 0 012.823-4.588c1.177-1.294 2.706-2.353 4.471-3.177 1.765-.823 3.647-1.176 5.647-1.176 1.294 0 2.588.117 3.882.47 1.295.353 2.471.941 3.647 1.883 1.059.823 2 2 2.706 3.411.706 1.412 1.059 3.06 1.059 5.059.117.941 0 1.765-.236 2.706zM164.822 16c-.588 0-1.176.235-1.882.588-.706.47-1.176 1.177-1.647 2.235-.47 1.06-.706 2.353-.824 3.765l8.235-1.059c-.116-1.882-.588-3.294-1.176-4.235-.588-.823-1.529-1.294-2.706-1.294zm17.177 36l-2.352-7.647c.235 0 1.059-.118 2.588-.236 1.529-.117 2.823-.352 3.764-.705 1.059-.353 2.001-.824 2.824-1.647.824-.706 1.647-1.648 2.235-2.706l-10.47-22.706-3.176-2.588V12.47h15.647v1.294l-3.177 2.588 5.294 12.941 4.823-12.941-3.176-2.588V12.47h10.823v1.294l-3.411 2.588-9.412 22.823c-1.53 3.648-2.706 6.236-3.647 7.647-.941 1.412-2.117 2.589-3.53 3.412-1.411.824-3.294 1.412-5.647 1.765zm47.882-21.059c0 2.824-1.059 4.941-3.176 6.47-2.118 1.412-5.059 2.236-8.824 2.236-1.294 0-2.588-.118-3.882-.236-1.294-.117-2.941-.588-4.706-1.058v-8.824h1.295l4.117 6.118c.824.235 1.646.47 2.235.47 3.059 0 4.706-.94 4.706-2.705 0-.471-.236-1.06-.706-1.647-.47-.589-1.765-1.412-3.882-2.353-2.236-.941-3.765-1.883-4.706-2.706-.941-.824-1.648-1.647-2.118-2.706-.471-1.059-.706-2.235-.706-3.53 0-2.47.942-4.588 2.941-6.117 2.001-1.53 4.707-2.353 8.236-2.353 2.588 0 4.941.47 7.293 1.53v7.764h-1.293l-3.882-5.53c-2.001 0-3.294.236-3.883.707-.706.47-.941 1.176-.941 2 0 .352.117.705.235 1.058.235.353.471.706.941 1.06.471.352 1.883 1.058 4.353 2.235 2.471 1.176 4.236 2.352 5.059 3.646.824 1.295 1.294 2.706 1.294 4.471z"
                ></path>
              </svg>
            </div> */}
            <div className="w-full px-4 py-8 overflow-scroll no-scrollbar sm:w-fit sm:pt-24">
              <div className="flex flex-col items-center justify-center w-full max-w-xl mx-auto">
                <div className="flex items-center justify-center w-full p-2">
                  <Link href="/">
                    <div className="inline-block select-none">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 230 52" className="h-8">
                        <path
                          fill="#fff"
                          d="M26.235 34.235V23.529H13.176v10.706l3.883 3.53v1.294H0v-1.295l3.882-3.529V8.588L0 5.058V3.766h17.059V5.06l-3.883 3.53v11.176h13.06V8.588l-3.883-3.53V3.766H39.41V5.06l-3.882 3.53v25.646l3.882 3.53v1.294H22.235v-1.295l4-3.529zM44.823 18.47l-3.176-2.352v-1.294L53.41 12v15.53c0 1.882.353 3.293.941 4.235.589.823 1.647 1.294 3.059 1.294 1.176 0 2.588-.353 4.118-.941V18.47l-3.177-2.353v-1.294L70.117 12v22.117l4.235 1.648v1.294l-9.294 2.706-3.53-4.706c-.94 1.411-2 2.47-3.411 3.294-1.412.823-2.941 1.176-4.588 1.176-2.706 0-4.824-.823-6.353-2.47-1.647-1.647-2.47-3.883-2.47-6.706V18.47h.117zm52.235 16.706V24c0-3.647-1.294-5.53-3.882-5.53-1.647 0-3.177.471-4.706 1.412v15.294l2.942 2.588v1.295H76.588v-1.294l3.176-2.589v-16.47l-3.411-2.47V14.94L86 11.882l1.647 4.824c1.411-1.53 2.941-2.706 4.47-3.53 1.53-.823 3.177-1.176 5.06-1.176 2.587 0 4.705.823 6.234 2.47 1.529 1.648 2.353 3.883 2.353 6.706v14.118L108.94 38v1.294H94.117V38l2.941-2.824zm26.118-29.411v6.588h7.058v3.764h-7.058v14c0 1.883.353 3.177.941 3.883s1.647 1.059 2.941 1.059c1.412 0 2.824-.118 3.882-.471v1.294c-.47.47-1.176 1.059-2.235 1.647-.941.588-2.117 1.177-3.412 1.53-1.293.352-2.588.588-3.764.588-2.236 0-4-.588-5.294-2-1.294-1.294-1.883-3.177-1.883-5.53v-16h-4.118v-2.47l4.118-.588V7.765l8.824-2zm13.175 29.411V6.471l-3.176-2.353V2.824L144.94 0v35.176l3.176 2.588v1.294h-14.941v-1.294l3.176-2.588zm39.765-9.882h-15.647c.118 2 .471 3.647.942 4.941.471 1.412 1.412 2.47 2.588 3.294 1.177.824 2.941 1.294 5.177 1.294 1.764 0 3.764-.353 5.882-1.176l.823 1.647c-1.176 1.294-2.706 2.235-4.588 3.059-1.882.823-3.882 1.176-6.235 1.176-4.353 0-7.765-1.176-10.236-3.53-2.47-2.352-3.646-5.646-3.646-9.882 0-1.882.352-3.647.941-5.411a11.568 11.568 0 012.823-4.588c1.177-1.294 2.706-2.353 4.471-3.177 1.765-.823 3.647-1.176 5.647-1.176 1.294 0 2.588.117 3.882.47 1.295.353 2.471.941 3.647 1.883 1.059.823 2 2 2.706 3.411.706 1.412 1.059 3.06 1.059 5.059.117.941 0 1.765-.236 2.706zM164.822 16c-.588 0-1.176.235-1.882.588-.706.47-1.176 1.177-1.647 2.235-.47 1.06-.706 2.353-.824 3.765l8.235-1.059c-.116-1.882-.588-3.294-1.176-4.235-.588-.823-1.529-1.294-2.706-1.294zm17.177 36l-2.352-7.647c.235 0 1.059-.118 2.588-.236 1.529-.117 2.823-.352 3.764-.705 1.059-.353 2.001-.824 2.824-1.647.824-.706 1.647-1.648 2.235-2.706l-10.47-22.706-3.176-2.588V12.47h15.647v1.294l-3.177 2.588 5.294 12.941 4.823-12.941-3.176-2.588V12.47h10.823v1.294l-3.411 2.588-9.412 22.823c-1.53 3.648-2.706 6.236-3.647 7.647-.941 1.412-2.117 2.589-3.53 3.412-1.411.824-3.294 1.412-5.647 1.765zm47.882-21.059c0 2.824-1.059 4.941-3.176 6.47-2.118 1.412-5.059 2.236-8.824 2.236-1.294 0-2.588-.118-3.882-.236-1.294-.117-2.941-.588-4.706-1.058v-8.824h1.295l4.117 6.118c.824.235 1.646.47 2.235.47 3.059 0 4.706-.94 4.706-2.705 0-.471-.236-1.06-.706-1.647-.47-.589-1.765-1.412-3.882-2.353-2.236-.941-3.765-1.883-4.706-2.706-.941-.824-1.648-1.647-2.118-2.706-.471-1.059-.706-2.235-.706-3.53 0-2.47.942-4.588 2.941-6.117 2.001-1.53 4.707-2.353 8.236-2.353 2.588 0 4.941.47 7.293 1.53v7.764h-1.293l-3.882-5.53c-2.001 0-3.294.236-3.883.707-.706.47-.941 1.176-.941 2 0 .352.117.705.235 1.058.235.353.471.706.941 1.06.471.352 1.883 1.058 4.353 2.235 2.471 1.176 4.236 2.352 5.059 3.646.824 1.295 1.294 2.706 1.294 4.471z"
                        ></path>
                      </svg>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="relative flex-1 w-full max-w-lg mx-auto text-white">
                <div className="w-full text-white">
                  <h1 className={[`mt-1 text-3xl font-medium text-white drop-shadow transition-all duration-300`].join(" ")}>
                    This article doesn't exist
                  </h1>
                  <p className="mt-2 text-sm text-justify">It appears that the article you're searching for doesn't exist.</p>
                </div>
                <div className={`flex-col flex w-full gap-y-8 mt-6 transition-all duration-300`}>
                  <Link
                    className="block w-full py-4 font-medium text-center transition-all duration-300 rounded shadow-sm bg-cpink text-stone-900 hover:bg-white drop-shadow-xl hover:drop-shadow-sm"
                    href="/buy"
                  >
                    Properties for Sale
                  </Link>
                  <Link
                    className="block w-full py-4 font-medium text-center transition-all duration-300 rounded shadow-sm bg-cpink text-stone-900 hover:bg-white drop-shadow-xl hover:drop-shadow-sm"
                    href="/rent"
                  >
                    Properties for Rent
                  </Link>
                  <Link
                    className="block w-full py-4 font-medium text-center transition-all duration-300 rounded shadow-sm bg-cpink text-stone-900 hover:bg-white drop-shadow-xl hover:drop-shadow-sm"
                    href={`https://insights.street.co.uk/l/75b648ae-f226-4cee-bd9b-3ed5fa457c76/property-search`}
                    target="_blank"
                  >
                    Get a property report
                  </Link>
                  <Link
                    href="/landlords"
                    className="block w-full py-4 font-medium text-center transition-all duration-300 rounded shadow-sm bg-cpink text-stone-900 hover:bg-white drop-shadow-xl hover:drop-shadow-sm"
                  >
                    Information for Landlords
                  </Link>
                  <Link
                    href="https://huntleys.typeform.com/to/l3cj1d6T?typeform-source=www.huntleys.net"
                    className="block w-full py-4 font-medium text-center transition-all duration-300 rounded shadow-sm bg-cpink text-stone-900 hover:bg-white drop-shadow-xl hover:drop-shadow-sm"
                    target="_blank"
                  >
                    Apply to Rent Online
                  </Link>
                </div>
              </div>
              <div className="flex justify-center mt-8 gap-x-10 drop-shadow-xl">
                <Link href="https://facebook.com/huntleys.net" target="_blank">
                  <BsFacebook className="w-6 h-6 text-white sm:h-6.5 sm:w-6.5 hover:text-cpink transition-all duration-300 hover:drop-shadow-none" />
                </Link>
                <Link href="https://instagram.com/huntleysestateagents" target="_blank">
                  <BsInstagram className="w-6 h-6 text-white sm:h-6.5 sm:w-6.5 hover:text-cpink transition-all duration-300 hover:drop-shadow-none" />
                </Link>
                <Link href="https://tiktok.com/@huntleysestateagents" target="_blank">
                  <FaTiktok className="w-6 h-6 text-white sm:h-6.5 sm:w-6.5 hover:text-cpink transition-all duration-300 hover:drop-shadow-none" />
                </Link>
                <Link href="https://www.youtube.com/channel/UCNANHWjDiT9bgMiKloY-CDw" target="_blank">
                  <BsYoutube className="w-6 h-6 text-white sm:h-6.5 sm:w-6.5 hover:text-cpink transition-all duration-300 hover:drop-shadow-none" />
                </Link>
                <Link href="https://www.linkedin.com/company/10636175/" target="_blank">
                  <BsLinkedin className="w-6 h-6 text-white sm:h-6.5 sm:w-6.5 hover:text-cpink transition-all duration-300 hover:drop-shadow-none" />
                </Link>
                <Link href="https://twitter.com/HuntleysLet" target="_blank">
                  <BsTwitter className="w-6 h-6 text-white sm:h-6.5 sm:w-6.5 hover:text-cpink transition-all duration-300 hover:drop-shadow-none" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <Menu />
      </>
    )
  }

  const URL = `https://huntleys.net/articles/${post.slug}`

  const desc = post.excerpt

  const [category, setCategory] = useState("All")

  const [showCopiedClipboard, setShowCopiedClipboard] = useState(false)

  useEffect(() => {
    if (!showCopiedClipboard) return

    const timeout = setTimeout(() => {
      setShowCopiedClipboard(false)
    }, 625)

    return () => clearTimeout(timeout)
  }, [showCopiedClipboard])

  return (
    <div className="bg-stone-100">
      <NextSeo
        title={post.title}
        description={desc}
        openGraph={{ images: [{ url: post.feature_image.replaceAll("http://", "https://") }] }}
      />
      <div className="w-full">
        <div className="h-[50vh] bg-cpink">
          <img
            className="object-cover w-full h-full select-none"
            src={post.feature_image.replaceAll("http://", "https://")}
            alt={post.title}
          />
        </div>
        <div className="flex items-center justify-center">
          <div className="flex items-center justify-center px-4 pt-6 md:pt-8">
            <div className="flex flex-col items-center justify-center gap-0 mx-auto md:gap-6 sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl text-stone-900">
              <p className="text-xs uppercase text-stone-500">{dayjs(post.published_at).format("DD MMMM YYYY")}</p>
              <h1 className="max-w-screen-sm mt-4 font-serif text-3xl font-bold leading-snug text-center md:text-4xl">
                {post.title}
              </h1>
              <div
                className="text-[15px] leading-[1.5] mt-10 text-justify text-stone-800 font-light flex flex-col gap-6 md:gap-8 blog-post"
                dangerouslySetInnerHTML={{ __html: post.html }}
              ></div>
            </div>
          </div>
        </div>
        <div className="flex justify-center px-4 mt-2 mb-8 text-center">
          <div className="flex items-center justify-center w-full sm:w-auto sm:max-w-screen-sm md:max-w-screen-md xl:max-w-screen-xl">
            <Link href="/articles" className="w-full">
              <button
                aria-label="View all articles"
                className="w-full px-4 py-3 mt-6 font-medium transition-all duration-300 border-2 rounded select-none text-stone-900 bg-cpink border-cpink hover:bg-white hover:border-white"
              >
                View more articles
              </button>
            </Link>
          </div>
        </div>
        <div className="px-4 bg-cpink">
          <div className="flex items-center justify-center py-8">
            <div className="flex flex-col items-end justify-between w-full md:flex-row sm:max-w-screen-sm md:max-w-screen-md xl:max-w-screen-xl">
              <div className="flex w-full gap-4 md:w-fit">
                <div className="items-center aspect-[2/3] h-28 overflow-hidden select-none bg-cpink">
                  <img
                    alt="author"
                    src={`/images/${post.authors?.[0].name.toLowerCase()}.webp`}
                    className="object-cover w-full h-full"
                  />
                </div>
                <div className="flex flex-col justify-end">
                  <p className="text-xs text-stone-800">Written By</p>
                  <div className="mt-1">
                    <p className="text-stone-900 text-md">{post.authors?.[0].name}</p>
                    <p className="text-sm text-stone-800">
                      {(() => {
                        const name = post.authors?.[0].name

                        if (name === "Rebecca") return "Sales Managing Director"
                        else if (name === "Ben") return "Sales Negotiator"
                        else if (name === "Andrew") return "Director"
                        else if (name === "Abdul") return "Tech Lead"
                        else if (name === "Kyfer") return "Lettings Valuer"
                        else if (name === "Ellie") return "Office Manager"

                        return "Property Manager"
                      })()}
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full mt-6 md:w-fit md:mt-0 border-stone-900 text-stone-900">
                <p className="text-[15px] font-light">Share this article</p>
                <div className="flex mt-3 gap-x-6 gap-y-2">
                  <div>
                    <FacebookShareButton
                      url={URL}
                      // quote={"next-share is a social share buttons for your next React apps."}
                      hashtag={"#huntleysestateagents"}
                    >
                      <div className="flex items-center justify-center w-10 h-10 overflow-hidden transition-all duration-300 border rounded-full text-stone-900 border-stone-900 hover:bg-cpink hover:text-stone-900">
                        <FaFacebookF className="w-4 h-4" />
                      </div>
                    </FacebookShareButton>
                  </div>
                  <div>
                    <WhatsappShareButton url={URL} subject={`${post.title}`}>
                      <div className="flex items-center justify-center w-10 h-10 overflow-hidden transition-all duration-300 border rounded-full text-stone-900 border-stone-900 hover:bg-cpink hover:text-stone-900">
                        <FaWhatsapp className="w-6 h-6" />
                      </div>
                    </WhatsappShareButton>
                  </div>
                  <div>
                    <EmailShareButton url={URL} subject={`${post.title}`} body={`Here's an article I found: `}>
                      <div className="flex items-center justify-center w-10 h-10 overflow-hidden transition-all duration-300 border rounded-full text-stone-900 border-stone-900 hover:bg-cpink hover:text-stone-900">
                        <BsEnvelopeAt className="w-5 h-5" />
                      </div>
                    </EmailShareButton>
                  </div>
                  <div>
                    <Popover
                      isOpen={showCopiedClipboard}
                      positions={["bottom"]}
                      content={
                        <div className="px-4 py-2">
                          <div className="px-3 py-2 bg-white rounded shadow-2xl text-stone-900">Copied to clipboard.</div>
                        </div>
                      }
                    >
                      <button
                        aria-label="Copy to clipboard"
                        onClick={() => {
                          navigator?.clipboard?.writeText(URL)
                          setShowCopiedClipboard(true)
                        }}
                      >
                        <div className="flex items-center justify-center w-10 h-10 overflow-hidden transition-all duration-300 border rounded-full text-stone-900 border-stone-900 hover:bg-cpink hover:text-stone-900">
                          <BsLink45Deg className="w-6 h-6" />
                        </div>
                      </button>
                    </Popover>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Menu />
    </div>
  )
}

export default BlogPost

